import 'react-phone-input-2/lib/style.css';

import { Button, Helper, Input, PhoneInput, Typography } from '@smartgift/frontend-toolkit';
import { useFormik } from 'formik';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { MAX_FIRST_NAME_LENGTH, MAX_LAST_NAME_LENGTH } from '@hero/constants';
import { PasswordInput } from '@hero/molecules';
import { contactInfoSchema } from '@hero/schemas';
import { handleRedirectSignIn } from '@hero/utils';

import * as S from './style';

const SignUpContact = ({ activeStep, setActiveStep, signUpData, setSignUpData }) => {
  const { t } = useTranslation();

  const formik = useFormik({
    initialValues: {
      firstName: signUpData?.firstName ?? '',
      lastName: signUpData?.lastName ?? '',
      phone: signUpData?.phone ?? '',
      password: signUpData?.password ?? '',
      confirmPassword: signUpData?.confirmPassword ?? ''
    },
    validationSchema: contactInfoSchema,
    onSubmit: data => {
      setSignUpData({ ...signUpData, ...data });
      setActiveStep(activeStep + 1);
    }
  });

  return (
    <S.SignUpContact>
      <Typography variant="h4">{t('contactInformation')}</Typography>
      <S.SignUpContactForm>
        <S.SignUpContactFormGroup>
          <Input
            label={`${t('firstName')}*`}
            name="firstName"
            onChange={formik.handleChange}
            variant="outlined"
            value={formik.values.firstName}
            inputProps={{ maxLength: MAX_FIRST_NAME_LENGTH }}
          />
          <Input
            label={`${t('lastName')}*`}
            name="lastName"
            onChange={formik.handleChange}
            variant="outlined"
            value={formik.values.lastName}
            maxLength={{ maxLength: MAX_LAST_NAME_LENGTH }}
          />
        </S.SignUpContactFormGroup>

        <PhoneInput
          name="phone"
          inputProps={{
            required: true,
            placeholder: t('phone')
          }}
          onChange={value => formik.setFieldValue('phone', value)}
          countryCodeEditable
          country={'us'}
          value={formik.values.phone}
        />

        <PasswordInput
          hasError={formik.values.password && formik.errors.password}
          showPasswordBox
          name="password"
          onChange={formik.handleChange}
          value={formik.values.password}
        />
        {formik.values.password && formik.errors.password && formik.values.password.length < 8 && (
          <Helper text={t('passwordLengthWarning')} error />
        )}
        <PasswordInput
          name="confirmPassword"
          placeholder="confirmPassword"
          onChange={formik.handleChange}
          value={formik.values.confirmPassword}
        />

        <Button
          color="primary"
          disabled={!formik.isValid || !formik.values.firstName}
          onClick={formik.handleSubmit}
          style={{ marginBottom: '12px' }}
          block
        >
          {t('continue')}
        </Button>
      </S.SignUpContactForm>
      <S.SignUpContactFooter>
        <Typography variant="body2">{t('alreadyHeaveAnAccount')}?</Typography>
        <Button onClick={() => handleRedirectSignIn()} variant="link" color="fg">
          {t('signIn')}
        </Button>
      </S.SignUpContactFooter>
    </S.SignUpContact>
  );
};

export { SignUpContact };
